'use strict';

var $ = require('jquery');

var win = $(window);
var body = $(document.body);

var state = {
	prev : null,
	curr : null
};
var breakpoint = {
	prev : null,
	curr : null
};

var _tracker;
function getTracker() {
	if (_tracker === undefined) {
		var elem = document.createElement('div');
		elem.id = 'ViewportTracker';
		_tracker = $(elem);
		body.append(_tracker);
	}
	return _tracker;
}

function getState() {
	return $('header .menuTriggers').css('display') == 'block' ? 'mobile' : 'desktop';
}
function getBreakpoint() {
	return getTracker().width();
}

function onResize() {
	breakpoint.prev = breakpoint.curr;
	breakpoint.curr = getBreakpoint();
	if (breakpoint.prev != breakpoint.curr){
		win.triggerHandler('ViewportTracker:breakpoint', [breakpoint.curr]);
	}
	
	state.prev = state.curr;
	state.curr = getState();
	if (state.prev != state.curr){
		win.triggerHandler('ViewportTracker:state', [state.curr]);
	}
}
win.on('resize', onResize);
win.on('load', onResize);

var ViewportTracker = {
	getState: getState,
	getBreakpoint: getBreakpoint
};

module.exports = ViewportTracker;
